// Atributos de piel (estilo Typology) que se piden en el registro y en la
// activación de cuentas importadas. Se guardan en metadata del cliente
// (sebum, age_range, sensitive_skin, skin_type). Deben coincidir con
// PROFILE_OPTIONS del backend (src/lib/activation.ts).
export const SKIN_ATTRS = [
  { name: 'sebum', label: 'Nivel de sebo', options: ['Seca', 'Grasa', 'Mixta', 'Normal'] },
  { name: 'ageRange', label: 'Rango de edad', options: ['18-24', '25-34', '35-44', '45-54', '55-64', '65+'] },
  { name: 'sensitive', label: 'Piel sensible', options: ['Sí', 'No'] },
  {
    name: 'skinType',
    label: 'Tipo de piel',
    options: [
      'AE(•)', 'AE(-)', 'AE(+)', 'AP(+)', 'AP(•)', 'AP(-)',
      'DE(+)', 'DE(•)', 'DE(-)', 'DP(+)', 'DP(•)', 'DP(-)',
      'VE(+)', 'VE(•)', 'VE(-)', 'VP(+)', 'VP(•)', 'VP(-)',
      'PE(+)', 'PE(•)', 'PE(-)', 'PP(+)', 'PP(•)', 'PP(-)',
    ],
  },
];

export const GENDER_OPTIONS = [
  { value: '', label: 'Prefiero no decirlo' },
  { value: 'f', label: 'Femenino' },
  { value: 'm', label: 'Masculino' },
];
